module.exports = __webpack_public_path__ + "static/media/cover.ef12ad52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/rebtel/cover.jpg
// module id = 57
// module chunks = 0